// import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
// import {findCampaignsByUserId} from 'components/graphql/queries'
import React, { useState } from 'react'
import { connect } from 'react-redux';
import Switch from 'react-switch'
import UserDucks from 'stores/ducks/User.duck';

import { Card, CardBody, CardImg, CardSubtitle } from 'reactstrap';
import CampaignsCardBody from './CampaignCard.Body';

interface ICampaignListProps {
    campaigns: any[];
}
const CampaignsList: React.FC<ICampaignListProps> = (props: any) => {

    let activeCount = 0;
    let inactiveCount = 0;
    let activeCountMobile = 0;
    let inactiveCountMobile = 0;

    const [showfinishedMobile, setShowFinishedMobile] = useState(false)

    return <div className='container'>
        <div className="big-split">
            {
                <div style={{ height: '320px', width: '100%', }}>
                    <h4 style={{ paddingBottom: '15px' }}>
                        <br />Upcoming
                    </h4>
                    <div style={{ display: "flex", overflowX: "scroll" }}>
                        {
                            props.campaigns.map((campaign) => {
                                if (campaign.isActive) {
                                    activeCount++;
                                    let content = <div />;
                                    if (campaign.createdBy.trim() === props.user.id.trim()) {
                                        content = <span className="notify-owner" style={{ fontSize: '12px' }}>OWNER</span>
                                    } else {
                                        if (!props.user.isAdmin) {
                                            content = <span className="notify-affiliate" style={{ fontSize: '12px' }}>AFFILIATE</span>
                                        }
                                    }
                                    return <div style={{ marginRight: '30px' }} key={campaign.id}>
                                        <a
                                            href={'/campaign/' + campaign.id}
                                            style={{ textDecoration: 'none' }}
                                        >
                                            <Card
                                                style={{
                                                    width: '320px',
                                                    cursor: 'pointer',
                                                    marginBottom: '45px',
                                                    borderRadius: '20px'
                                                }}>
                                                <div style={{ height: '140px', overflowY: 'hidden' }}>
                                                    {content}
                                                    <CardImg top={true}
                                                        src={campaign.media.cover ? campaign.media.cover : 'https://platform.isotopeticketing.com/landing.png'}
                                                        alt="Campaign Image"
                                                        style={{
                                                            borderTopLeftRadius: '15px',
                                                            borderTopRightRadius: '15px',
                                                            objectFit: 'cover',
                                                            height: '140px'
                                                        }}
                                                    />
                                                </div>
                                                <div className="events-page-manage-inside">
                                                    <CardBody>
                                                        <CardSubtitle>
                                                            <CampaignsCardBody
                                                                name={campaign.name}
                                                                totalSold={campaign.directSales + campaign.indirectSales}
                                                                totalRevenue={campaign.totalEarnings}
                                                                payoutDate={campaign.payoutDate}
                                                            />
                                                        </CardSubtitle>
                                                    </CardBody>
                                                </div>
                                            </Card>
                                        </a>
                                    </div>
                                } else {
                                    return null
                                }
                            })
                        }
                        {
                            activeCount === 0 ?
                                <h3 className='gray-text'>
                                    No upcoming campaigns.
                                </h3> : null
                        }
                    </div>
                </div>
            }
            {
                <div style={{ height: '320px', width: '100%' }}>
                    <h4 style={{ paddingBottom: '15px', paddingTop: '15px' }}>
                        <br />Past
                    </h4>
                    <div style={{ display: "flex", overflowX: "scroll" }}>
                        {
                            props.campaigns.map((campaign) => {
                                if (!campaign.isActive) {
                                    inactiveCount++;
                                    let content = <div />;
                                    if (campaign.createdBy.trim() === props.user.id.trim()) {
                                        content = <span className="notify-owner" style={{ fontSize: '12px' }}>OWNER</span>
                                    } else {
                                        if (!props.user.isAdmin) {
                                            content = <span className="notify-affiliate" style={{ fontSize: '12px' }}>AFFILIATE</span>
                                        }
                                    }
                                    return <div style={{ marginRight: '30px' }} key={campaign.id}>
                                        <a
                                            href={'/campaign/' + campaign.id}
                                            style={{ textDecoration: 'none' }}
                                        >
                                            <Card
                                                style={{
                                                    width: '320px',
                                                    cursor: 'pointer',
                                                    marginBottom: '45px',
                                                    borderRadius: '20px'
                                                }}>
                                                <div style={{ height: '140px', overflowY: 'hidden' }}>
                                                    {content}
                                                    <CardImg top={true}
                                                        src={campaign.media.cover ? campaign.media.cover : 'https://platform.isotopeticketing.com/landing.png'}
                                                        alt="Campaign Image"
                                                        style={{
                                                            borderTopLeftRadius: '15px',
                                                            borderTopRightRadius: '15px',
                                                            objectFit: 'cover',
                                                            height: '140px'
                                                        }}
                                                    />
                                                </div>
                                                <div className="events-page-manage-inside">
                                                    <CardBody>
                                                        <CardSubtitle>
                                                            <CampaignsCardBody
                                                                name={campaign.name}
                                                                totalSold={campaign.directSales + campaign.indirectSales}
                                                                totalRevenue={campaign.totalEarnings}
                                                                payoutDate={campaign.payoutDate}
                                                            />
                                                        </CardSubtitle>
                                                    </CardBody>
                                                </div>
                                            </Card>
                                        </a>
                                    </div>
                                } else {
                                    return null
                                }
                            })
                        }
                    </div>
                    {
                        inactiveCount === 0 ?
                            <h3 className='gray-text'>
                                No past campaigns.
                            </h3> : null
                    }
                </div>
            }
        </div>
        <div className='small-split' style={{ paddingLeft: '20px', paddingRight: '20px' }}>
            <div style={{ width: '100%', paddingBottom: '20px', display: 'flex', flexDirection: 'row' }}>
                <div className='gray-text' style={{ float: 'left', height: '35px', width: '40%', paddingTop: '1px' }}>
                    <span>
                        Your Events
                    </span>
                </div>
                <div style={{ float: 'right', width: '60%', textAlign: 'right' }}>
                    <span style={{ height: '20px', lineHeight: '15px', color: '#242d51', fontWeight: 'bold' }}>
                        Upcoming&nbsp;&nbsp;</span>
                    <span style={{ height: '20px', lineHeight: '15px', paddingTop: '5px' }}>
                        <Switch
                            checked={showfinishedMobile}
                            onChange={e => setShowFinishedMobile(!showfinishedMobile)}
                            onColor="#1931b9"
                            onHandleColor="#ffffff"
                            handleDiameter={20}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0 2px 1px -1px gray"
                            height={20}
                            width={35}
                            className="react-switch"
                            id="material-switch"
                        />
                    </span>
                    <span style={{ height: '20px', lineHeight: '15px', color: '#242d51', fontWeight: 'bold' }}>
                        &nbsp;&nbsp;Past
                    </span>
                </div>
            </div>
            {
                props.campaigns.map((campaign) => {
                    if (campaign.isActive && !showfinishedMobile) {
                        activeCountMobile++;
                        let content = <div />;
                        if (campaign.createdBy.trim() === props.user.id.trim()) {
                            content = <span className="notify-owner" style={{ fontSize: '12px' }}>OWNER</span>
                        } else {
                            if (!props.user.isAdmin) {
                                content = <span className="notify-affiliate" style={{ fontSize: '12px' }}>AFFILIATE</span>
                            }
                        }
                        return (
                            <div style={{ marginRight: '20px' }} key={campaign.id}>
                                <a
                                    href={'/campaign/' + campaign.id}
                                    style={{ textDecoration: 'none' }}
                                >
                                    <Card
                                        style={{
                                            width: '360px',
                                            cursor: 'pointer',
                                            marginBottom: '45px',
                                            borderRadius: '20px',
                                            maxWidth: '105%'
                                        }}>
                                        <div style={{ height: '140px', overflowY: 'hidden' }}>
                                            {content}
                                            <CardImg top={true}
                                                src={campaign.media.cover ? campaign.media.cover : 'https://platform.isotopeticketing.com/landing.png'}
                                                alt="Event Image"
                                                style={{
                                                    borderTopLeftRadius: '15px',
                                                    borderTopRightRadius: '15px',
                                                    objectFit: 'cover',
                                                    height: '140px'
                                                }}
                                            />
                                        </div>
                                        <div className="events-page-manage-inside">
                                            <CardBody>
                                                <CardSubtitle>
                                                    <CampaignsCardBody
                                                        name={campaign.name}
                                                        totalSold={campaign.directSales + campaign.indirectSales}
                                                        totalRevenue={campaign.totalEarnings}
                                                        payoutDate={campaign.payoutDate}
                                                    />
                                                </CardSubtitle>
                                            </CardBody>
                                        </div>
                                    </Card>
                                </a>
                            </div>)
                    } else if (!campaign.isActive && showfinishedMobile) {
                        inactiveCountMobile++;
                        let content = <div />;
                        if (campaign.createdBy.trim() === props.user.id.trim()) {
                            content = <span className="notify-owner" style={{ fontSize: '12px' }}>OWNER</span>
                        } else {
                            if (!props.user.isAdmin) {
                                content = <span className="notify-affiliate" style={{ fontSize: '12px' }}>AFFILIATE</span>
                            }
                        }
                        return (
                            <div style={{ marginRight: '20px' }} key={campaign.id}>
                                <a
                                    href={'/campaign/' + campaign.id}
                                    style={{ textDecoration: 'none' }}
                                >
                                    <Card
                                        style={{
                                            width: '360px',
                                            cursor: 'pointer',
                                            marginBottom: '45px',
                                            borderRadius: '20px',
                                            maxWidth: '105%'
                                        }}>
                                        <div style={{ height: '140px', overflowY: 'hidden' }}>
                                            {content}
                                            <CardImg top={true}
                                                src={campaign.media.cover ? campaign.media.cover : 'https://platform.isotopeticketing.com/landing.png'}
                                                alt="Event Image"
                                                style={{
                                                    borderTopLeftRadius: '15px',
                                                    borderTopRightRadius: '15px',
                                                    objectFit: 'cover',
                                                    height: '140px'
                                                }}
                                            />
                                        </div>
                                        <div className="events-page-manage-inside">
                                            <CardBody>
                                                <CardSubtitle>
                                                    <CampaignsCardBody
                                                        name={campaign.name}
                                                        totalSold={campaign.directSales + campaign.indirectSales}
                                                        totalRevenue={campaign.totalEarnings}
                                                        payoutDate={campaign.payoutDate}
                                                    />
                                                </CardSubtitle>
                                            </CardBody>
                                        </div>
                                    </Card>
                                </a>
                            </div>)
                    } else {
                        return null
                    }
                })
            }
            {
                activeCountMobile === 0 && !showfinishedMobile ?
                    <h6 className='gray-text' style={{ width: '100%', textAlign: 'center' }}>
                        No upcoming campaigns.
                    </h6> : null
            }
            {
                inactiveCountMobile === 0 && showfinishedMobile ?
                    <h6 className='gray-text' style={{ width: '100%', textAlign: 'center' }}>
                        No past campaigns.
                    </h6> : null
            }
        </div>
    </div>
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(CampaignsList);


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsPage/CampaignsList.tsx